export const getImportPage = state => state.query.importPage;
export const getImportRequestPage = state => state.query.importRequestPage;
